import { render, staticRenderFns } from "./animalFixedPlugin.vue?vue&type=template&id=d745a574&scoped=true&"
import script from "./animalFixedPlugin.vue?vue&type=script&lang=js&"
export * from "./animalFixedPlugin.vue?vue&type=script&lang=js&"
import style0 from "./animalFixedPlugin.vue?vue&type=style&index=0&id=d745a574&prod&lang=scss&scoped=true&"
import style1 from "./animalFixedPlugin.vue?vue&type=style&index=1&id=d745a574&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d745a574",
  null
  
)

export default component.exports